import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useQueryWrapper } from "../../../hooks";
import { MprService, OrganizationUnitDto } from "../../../openapi/edsn-webapi";
import { safePropertyMap } from "../../../utils";
import { SelectControl } from "../../common";
import { useIntl } from "react-intl";

type SubunitEan13SelectControlProps = {
  tooltip?: string;
  tooltipTranslated?: boolean;
  organisatieEan13Code: string;
};

const SubunitEan13SelectControl = ({
  tooltip,
  tooltipTranslated,
  organisatieEan13Code
}: SubunitEan13SelectControlProps) => {
  const intl = useIntl();

  const { data, isInitialLoading } = useQueryWrapper(
    [`getSubUnitsByMarketPartyId-${organisatieEan13Code}`],
    () => MprService.getMprMarketPartiesSubunits({ marketPartyEan: organisatieEan13Code }),
    { staleTime: Infinity, gcTime: Infinity }
  );

  const { setValue, setError, clearErrors } = useFormContext<OrganizationUnitDto>();

  const options = useMemo(
    () => Array.isArray(data) ? data.map((m) => ({
      value: m.ean!,
      label: `${m.ean} - ${m.name!}`,
    })) : [],
    [data]
  );

  const map = safePropertyMap<OrganizationUnitDto>();

  useEffect(() => {
    if (options.length) {
      setValue("ean13", options[0].value);
      clearErrors("ean13");
    } else if (!isInitialLoading) {
      setError("ean13", {
        type: "manual",
        message: intl.formatMessage({ id: "NoSubUnitsFoundForOrganization" })
      });
    }
  }, [options, isInitialLoading, setValue, setError, clearErrors]);

  return (
    <SelectControl
      options={options}
      name={map("ean13")}
      label="eanCodeMarket"
      tooltip={tooltip}
      tooltipTranslated={!!tooltipTranslated}
      required
      isLoading={isInitialLoading}
    />
  );
};

export default SubunitEan13SelectControl;
